import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";
import { Button } from "@trillion/ui/components/ui/button";
import { PageHeader } from "@trillion/ui/components/admin/page-header";
import { PlacementForm } from "@/components/placements/placement-form";
import { adminApi } from "@/lib/admin-api";
import { describeApiError } from "@/lib/api-error";
import type { Placement } from "@/types";

export function PlacementNewPage() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  async function handleSubmit(data: Partial<Placement>) {
    setIsLoading(true);
    try {
      await adminApi.placements.create(data);
      toast.success("Placement created successfully");
      navigate("/placements");
    } catch (err) {
      toast.error("Failed to create placement", {
        description: describeApiError(err),
      });
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="flex flex-col gap-6 p-6">
      <PageHeader
        title="New Placement"
        description="Add a new click placement label"
        actions={
          <Button variant="outline" onClick={() => navigate("/placements")}>
            <ArrowLeft className="mr-2 size-4" />
            Back to Placements
          </Button>
        }
      />
      <PlacementForm onSubmit={handleSubmit} isLoading={isLoading} />
    </div>
  );
}
